import React from "react";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import FollowingListActions from "./widget/FollowingListActions";
import {
  FollowingListContextImport,
  FollowingListContextProvider,
} from "../../../provider/notices/following_list/FollowingListContextProvider";
import FollowingListContent from "./FollowingListContent";
import FollowingListButtons from "./widget/FollowingListButtons";
import Scaffold from "../../../widget/layouts/Scaffold";

const FollowingListScreen = () => {
  return (
    <FollowingListContextProvider>
      <FollowingListScreenBody />
    </FollowingListContextProvider>
  );
};

const FollowingListScreenBody = () => {
  const type: number = ResponsiveDeviceType();

  const { deleteStatus } = FollowingListContextImport();

  return (
    <Scaffold
      appBarTitle={AppTranslation.text("following")}
      appBarAction={<FollowingListActions />}
      bottomNavigationButton={
        deleteStatus ? <FollowingListButtons type={type} /> : undefined
      }
    >
      <MainBodyContainer className="h-100">
        <FollowingListContent type={type} />
      </MainBodyContainer>
    </Scaffold>
  );
};

export default FollowingListScreen;
export const routeName: string = "/notices-following";
